import React from "react";

import styles from "./BonusMotivator.module.scss";

interface Props {
  text: string | null;
}

export const BonusMotivator: React.FC<Props> = ({ text }) => {
  if (!text) return null;

  return (
    <div className={styles.Container}>
      <p className={styles.Text}>{text}</p>
    </div>
  );
};